import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { GET_USER_GROUP_WITH_ROLES } from "./gql";
import { IdpGroupViewBindingRoleWithRole } from "./types";

type UseGetIdpGroupProps = {
  id?: string;
};

const useGetIdpGroup = ({ id }: UseGetIdpGroupProps) => {
  const { data, loading, error, refetch } = useQuery(GET_USER_GROUP_WITH_ROLES, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  const idpGroup = useMemo(
    () =>
      data
        ? {
            ...data.managedUserGroup,
            // TODO: [AAC] remove this once we have a BE improvements ready
            userRoleBindings: data.managedUserGroup.userRoleBindings.reduce(
              (acc, userRoleBinding) => {
                const role = data.roles.find((role) => role.id === userRoleBinding.roleID);
                if (!role) {
                  return acc;
                }

                return [
                  ...acc,
                  {
                    ...userRoleBinding,
                    role,
                  },
                ];
              },
              [] as IdpGroupViewBindingRoleWithRole[]
            ),
          }
        : undefined,
    [data]
  );

  return { idpGroup, loading, error, refetch };
};

export default useGetIdpGroup;
